import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { MessageRounded } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

interface CompareViewFeedbackActionProps {
  onViewFeedback: ({ isFieldA }: { isFieldA: boolean }) => void;
}

export const CompareViewFeedbackAction = ({
  onViewFeedback,
}: CompareViewFeedbackActionProps) => {
  const compareTo = useQuantifyStore(({ query }) => query.compareQuery);

  const compareByLabel = compareTo?.whereClause ? 'Filter' : 'Duration';

  return (
    <>
      <MenuItem
        onClick={() =>
          onViewFeedback({
            isFieldA: true,
          })
        }
      >
        <ListItemIcon>
          <MessageRounded
            sx={{
              color: 'text.disabled',
            }}
          />
        </ListItemIcon>
        <ListItemText primary={`View Feedback in ${compareByLabel} A`} />
      </MenuItem>
      <MenuItem
        onClick={() =>
          onViewFeedback({
            isFieldA: false,
          })
        }
      >
        <ListItemIcon>
          <MessageRounded
            sx={{
              color: 'text.disabled',
            }}
          />
        </ListItemIcon>
        <ListItemText primary={`View Feedback in ${compareByLabel} B`} />
      </MenuItem>
    </>
  );
};
